<template>
  <div class="slider">
    <v-carousel
        cycle
        height="100%"
        hide-delimiter-background
        show-arrows-on-hover
    >
        <v-carousel-item
            v-for="(banner, i) in banners"
            :key="i"
        >
        <v-sheet
            height="100%"
        >
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <div class="display-3">
                  <img :src="'https://ecodom04.com/backend/' + banner.img" alt="images">
              </div>
            </v-row>
        </v-sheet>
        </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: 'slider',
  components: {
  },
  data () {
      return {
        slides: [
          'First',
          'Second',
        ],
        banners: []
      }
  },
  methods: {
      getBanner() {
          fetch(this.$apiURI + 'public/banner/getall')
          .then((res) => {
              res.json().then((data) => {
                  this.banners = data
              });
          })

      }
  },
  mounted() {
    this.getBanner()
  }
}
</script>
<style  lang="less">
.display-3 {
    width: 100%;
    height: 100%;
    background: #ccc;
    img {
        width: 100%;
        height: 110%;
    }
}
.v-window__next {
    right: 0;
}
</style>